// Module
var code = "<react-component name=\"ArchivedMembershipPlansList\"></react-component>\n";
// Exports
module.exports = code;